import { createSlice } from '@reduxjs/toolkit';
import { getUserDetailAction } from './userDetailAction';

export const userDetailSlice = createSlice({
  name: 'userDetail',
  initialState: {
    loading: false,
    data: {},
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserDetailAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserDetailAction.fulfilled, (state, { payload }) => {      
      state.loading = false;
      state.data = payload.data;
      state.message = payload.message;
      state.error = null;
    });
    builder.addCase(getUserDetailAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
    });
  },
});
